export type EmbedRouteId = 'chatui' | 'dashboard'
export type SDKMountMode = 'inline' | 'floating'

export interface SDKResizeOptions {
  width?: number | string
  height?: number | string
}

export interface SDKConfig {
  baseUrl?: string
  pathPrefix?: string
  route?: EmbedRouteId
  container?: HTMLElement | string
  extData?: Record<string, unknown>
  resize?: SDKResizeOptions
  autoShow?: boolean
  mountMode?: SDKMountMode
}

export interface NormalizedSDKConfig {
  baseUrl: string
  pathPrefix: string
  route: EmbedRouteId
  container: HTMLElement | null
  extData: Record<string, unknown>
  resize: SDKResizeOptions
  autoShow: boolean
  mountMode: SDKMountMode
}

export const DEFAULT_SDK_CONFIG: Omit<NormalizedSDKConfig, 'container'> = {
  baseUrl: '',
  pathPrefix: '',
  route: 'dashboard',
  extData: {},
  resize: {
    width: 420,
    height: 720,
  },
  autoShow: true,
  mountMode: 'inline',
}